import { PageResponse } from "../types";
export function InventoryPagination<T>({
  page,
  setPage,
  size,
  setSize,
  data,
}: {
  page: number;
  setPage: (page: number) => void;
  size: number;
  setSize: (size: number) => void;
  data?: PageResponse<T> | null;
}) {
  const totalPages = data?.totalPages || 1;
  return (
    <div className="flex flex-col justify-between gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm shadow-sm md:flex-row md:items-center">
      <div className="text-slate-500">
        Showing page <span className="font-semibold text-slate-700">{page + 1}</span> of{" "}
        <span className="font-semibold text-slate-700">{totalPages}</span>
        {typeof data?.totalElements === "number" && (
          <span> • {data.totalElements.toLocaleString()} record(s)</span>
        )}
      </div>
      <div className="flex items-center gap-2">
        <select
          value={size}
          onChange={(event) => setSize(Number(event.target.value))}
          className="rounded-lg border border-slate-200 px-2 py-2 outline-none focus:border-emerald-600"
        >
          {[10, 25, 50, 100].map((option) => (
            <option key={option} value={option}>
              {option} rows
            </option>
          ))}
        </select>
        <button
          type="button"
          disabled={page <= 0}
          onClick={() => setPage(Math.max(0, page - 1))}
          className="rounded-lg border border-slate-200 px-3 py-2 font-semibold text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Previous
        </button>
        <button
          type="button"
          disabled={data?.last || page + 1 >= totalPages}
          onClick={() => setPage(page + 1)}
          className="rounded-lg border border-slate-200 px-3 py-2 font-semibold text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}
